<template>
    <!-- Componente para mostrar los formularios de la pre autorización de crédito y hacer las peticiones necesarias para cada paso -->
    <section
        id="bbva-form-f2"
        class="bbva-form-2 px-4 max-w-screen-lg xl:max-w-screen-xl mx-auto my-10"
    >
        <!-- Contenedor de botón para regresar al simulador -->
        <div class="my-4">
            <button
                class="flex items-center space-x-1 sm:space-x-2 hover:opacity-75"
                @click="$emit('back-to-simulator')"
            >
                <!-- <i
                    class="border-solid border-black inline-block p-1 mr-1"
                    style="border-width: 0 2px 2px 0; transform: rotate(135deg);"
                ></i> -->
                <span class="text-light-blue">
                    <i class="fa-solid fa-chevron-left fa-lg"></i>
                </span>
                <span class="inline-block text-sm sm:text-base">Regresar al simulador de crédito</span>
            </button>
        </div>
        <!-- Contenedor general para mostrar los formularios -->
        <div v-show="!showThankYouMsg">
            <h1 class="font-medium text-2xl lg:text-3xl mb-3 leading-tight">Pre autorización de crédito digital</h1>
            <div class="flex justify-between items-center leading-tight">
                <p>En 4 simples pasos, solicita tu pre autorización de crédito digital</p>
            </div>
            <div class="line border-solid border-b border-gray3 my-4"></div>
            <p class="text-xs sm:text-sm text-right"><span class="text-light-blue">*</span>Campos requeridos</p>
            <!-- Contenedor para el input del email y el botón para cargar el avance -->
            <div class="flex flex-col space-y-4 md:space-y-0 md:flex-row md:space-x-4 md:items-end">
                <label
                    class="flex flex-col"
                    for="email"
                >
                    <p class="font-medium text-sm sm:text-base">
                        Email*
                    </p>
                    <input
                        class="h-8 sm:h-10 px-2 text-sm focus:outline-none border-2 border-gray3 focus:border-light-blue w-56"
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Introduce tu email"
                        v-model="mainEmail"
                    >
                </label>
                <div class="flex flex-col space-y-2 md:space-y-0 md:flex-row md:space-x-2 md:items-center">
                    <p class="font-medium text-sm sm:text-base">¿Tienes un avance guardado?</p>
                    <button
                        class="relative z-10 hyundai-button w-32 py-1 h-8 sm:h-10"
                        :class="{ 'cursor-default': gettingProgress || getProgBtnDisabled, 'bg-gray4': getProgBtnDisabled }"
                        @click="getProgress"
                        :disabled="gettingProgress || getProgBtnDisabled"
                    >{{ !gettingProgress ? 'Cargar avance' : 'Cargando...' }}</button>
                </div>
            </div>
            <!-- Contenedor para el check principal para poder continuar con la pre autorización -->
            <div class="mt-8 flex text-sm text-light-blue">
                <checkbox-form
                    :name="'main-check'"
                    :value="mainCheck"
                    @click="onClickMainCheck"
                >
                    <p class="text-sm sm:text-base">Autorizo <span
                            class="text-dark-blue font-medium cursor-pointer"
                            @click="showModals.personalData = true"
                        >compartir mis datos personales con BBVA</span> para la evaluación del crédito.</p>
                </checkbox-form>
            </div>
            <p class="mt-4 lg:w-5/6 leading-tight">En caso de no terminar tu solicitud, BBVA utilizará tus datos de
                contacto para proporcionarte mayor información acerca de esta oferta.</p>
            <steps
                :class="!mainCheck ? 'opacity-50' : ''"
                :actualForm="actualForm"
            ></steps>
            <!-- Contenedor de los formularios -->
            <div
                class="space-y-2"
                :class="!mainCheck ? 'opacity-50' : ''"
            >
                <form-1
                    @form-validated="onFormValidated"
                    :main-check="mainCheck"
                    :actual-form="actualForm"
                    @form-open="onFormOpen"
                    @save-progress="onSaveProgress"
                    :saving-progress="savingProgress"
                    @charging-catalogs="onChargingCatalogs"
                ></form-1>
                <form-2
                    @form-validated="onFormValidated"
                    :main-check="mainCheck"
                    :actual-form="actualForm"
                    @form-open="onFormOpen"
                    @save-progress="onSaveProgress"
                    :saving-progress="savingProgress"
                    @charging-catalogs="onChargingCatalogs"
                ></form-2>
                <form-3
                    @form-validated="onFormValidated"
                    :main-check="mainCheck"
                    :actual-form="actualForm"
                    @form-open="onFormOpen"
                    @save-progress="onSaveProgress"
                    :saving-progress="savingProgress"
                    @charging-catalogs="onChargingCatalogs"
                ></form-3>
                <form-4
                    @form-validated="onFormValidated"
                    :main-check="mainCheck"
                    :actual-form="actualForm"
                    @form-open="onFormOpen"
                    @save-progress="onSaveProgress"
                    :saving-progress="savingProgress"
                    @charging-catalogs="onChargingCatalogs"
                    :main-email="mainEmail"
                    :full-name="fullName"
                ></form-4>
            </div>
            <div class="mt-8 flex justify-center">
                <button
                    type="button"
                    class="hyundai-button w-48 p-2"
                    :class="{ 'bg-gray4 cursor-default': !formsCompleted, 'cursor-default': loadingCreateCustomer }"
                    :disabled="!formsCompleted || loadingCreateCustomer"
                    @click="sendData"
                >{{ loadingCreateCustomer ? 'Enviando...' : 'Enviar' }}</button>
            </div>
        </div>
        <!-- Contenedor para mostrar el mensaje final -->
        <div
            class="sm:w-120 m-auto mt-8"
            v-show="showThankYouMsg"
        >
            <div v-html="thankYouMsg"></div>
            <div
                class="flex flex-col sm:flex-row"
                v-show="showClickToBuy"
            >
                <button
                    v-show="isC2bActive"
                    @click="goToClickToBuy"
                    class="hyundai-button mt-4 mx-auto w-56 px-4"
                >Continua tu compra Online en Cl!ck to Buy</button>
                <button
                    @click="goToDealerContact"
                    class="hyundai-button mt-4 mx-auto w-56 px-4"
                >Continua tu compra Offline con el Distribuidor</button>
            </div>
        </div>
        <!-- Formularios para los disclaimers -->
        <modal-form
            :show="showModals.personalData"
            @close="showModals.personalData = false"
        >
            <p class="font-medium text-center">Compartir mis datos personales con BBVA</p>
            <p class="mt-4 text-justify">Autorizo a Hyundai Motor de México, S. de R.L de C.V. que comparta mis datos
                personales, financieros y patrimoniales a BBVA México, S.A., Institución de Banca Múltiple, Grupo
                Financiero BBVA México, para la evaluación y en su caso el otorgamiento de un crédito de auto. Dichos
                datos serán tratados con apego al <span
                    class="text-light-blue underline cursor-pointer"
                    @click="onClickPrivacy"
                >Aviso de Privacidad BBVA.</span></p>
        </modal-form>
        <modal-form
            :show="showModals.privacyPolicy"
            @close="showModals.privacyPolicy = false"
        >
            <p class="font-medium">Aviso de Privacidad</p>
            <p class="mt-4 text-justify">BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México,
                con domicilio en Avenida Paseo de la Reforma número 510 Colonia Juárez Alcaldía Cuauhtémoc, Código
                Postal 06600, Ciudad de México, recaba tus datos personales para verificar tu identidad, así como para
                administrar, operar y dar seguimiento a los servicios y productos que solicitas o contratas. Puedes
                consultar el Aviso de Privacidad Integral en cualquiera de nuestras sucursales y en <a
                    href="https://www.bbva.mx"
                    class="text-light-blue underline"
                    target="_blank"
                >www.bbva.mx</a></p>
        </modal-form>
    </section>
</template>

<script>
import Swal from "sweetalert2";
export default {
    props: [
        "dataForF2",
        "appEnv",
        "isIframe",
        "inteColor",
        "extColor",
        "image"
    ],
    data() {
        return {
            url: $(".url").text(),
            webpage: $(".webpage").text(),
            mainEmail: this.dataForF2.mainEmail,
            mainCheck: false,
            actualForm: 0,
            // Variable to store data about model from configure version
            modelData: {
                dealerId: this.dataForF2.subsidiary,
                vehicle_id: this.dataForF2.versionId,
                year: this.dataForF2.modelYear,
                marketValue: this.dataForF2.versionPrice,
                downPayment: this.dataForF2.downpayment,
                number: this.dataForF2.term,
                casualtyInsurance: true,
                color: this.dataForF2.exColorSelected,
                interior_color: this.dataForF2.intColorSelected,
                bbva_api_call_id: this.dataForF2.bbvaQuotationId,
            },
            // Variable to store inputs from forms to send to back
            allInputs: {},
            // Variable para determinar si está cargando el avance
            // de los formularios
            gettingProgress: false,
            // Variable para determinar si se está guardando el avance
            // de los formularios
            savingProgress: false,
            // Variable para determinar qué modales mostrar
            showModals: {
                personalData: false,
                privacyPolicy: false,
            },
            // Variable para determinar si los formularios fueron completados
            formsCompleted: false,
            // Variable para determinar si se está haciendo la
            // petición final
            loadingCreateCustomer: false,
            // Variable para determinar si mostrar el mensaje final
            showThankYouMsg: false,
            // Variable para guardar el mensaje final
            thankYouMsg: "",
            // Variable para determinar si el botón de obtener el
            // avance se deshabilita
            getProgBtnDisabled: false,
            // Variable para determinar si mostrar el botón de Click to buy
            // en el mensaje final
            showClickToBuy: false,
            //Esta variable muestra u oculta el boton para ir Click to buy
            isC2bActive: false,
            // Variable para almacenar la url para redireccionar a Click to buy
            clickToBuyUrl: "",
        };
    },
    watch: {
        // Observa la variable mainCheck para mostrar el 1er
        // formulario cuando se le da lick
        mainCheck: function (newVal) {
            if (newVal) {
                if (!this.actualForm) {
                    this.actualForm = 1;
                }
                this.$eventBus.$emit(`show-form-${this.actualForm}`);
            } else {
                this.$eventBus.$emit(`hide-forms`);
            }
        },
        // Observadores para determinar si ocultar los formularios y
        // actualizar las variables para la pre autorización
        "dataForF2.casualtyInsurance": function (val) {
            this.modelData.casualtyInsurance = val === "insu" ? true : false;
            this.clickToBuyUrl = "";
            this.showClickToBuy = false;
            this.showThankYouMsg = false;
            this.thankYouMsg = "";
        },
        "dataForF2.subsidiary": function (val) {
            this.modelData.dealerId = val;
        },
        "dataForF2.versionId": function (val) {
            this.modelData.vehicle_id = val;
            this.clickToBuyUrl = "";
            this.showClickToBuy = false;
            this.showThankYouMsg = false;
            this.thankYouMsg = "";
            this.$emit("param-changed");
        },
        "dataForF2.versionPrice": function (val) {
            this.modelData.marketValue = val;
        },
        "dataForF2.downpayment": function (val) {
            this.modelData.downPayment = val;
            this.clickToBuyUrl = "";
            this.showClickToBuy = false;
            this.showThankYouMsg = false;
            this.thankYouMsg = "";
        },
        "dataForF2.term": function (val) {
            this.modelData.number = val;
            this.clickToBuyUrl = "";
            this.showClickToBuy = false;
            this.showThankYouMsg = false;
            this.thankYouMsg = "";
        },
        "dataForF2.exColorSelected": function (val) {
            this.modelData.color = val;
            this.clickToBuyUrl = "";
            this.showClickToBuy = false;
            this.showThankYouMsg = false;
            this.thankYouMsg = "";
            this.$emit("param-changed");
        },
        "dataForF2.intColorSelected": function (val) {
            this.modelData.interior_color = val;
            this.clickToBuyUrl = "";
            this.showClickToBuy = false;
            this.showThankYouMsg = false;
            this.thankYouMsg = "";
            this.$emit("param-changed");
        },
        "dataForF2.bbvaQuotationId": function (val) {
            this.modelData.bbva_api_call_id = val;
            this.clickToBuyUrl = "";
            this.showClickToBuy = false;
            this.showThankYouMsg = false;
            this.thankYouMsg = "";
        },
        "dataForF2.mainEmail": function (val) {
            this.mainEmail = val;
        },
    },
    methods: {
        // Función para enviar todos los datos necesarios para hacer la
        // petición para la pre autorización de crédito
        sendData() {

            this.loadingCreateCustomer = true;

            this.dataLayerPush('preautorizacion_bbva_confirmacion', 'enviado');

            axios
                .post("/bbva/create-customer", {
                    email: this.mainEmail,
                    data: { ...this.allInputs, ...this.modelData },
                })
                .then((resp) => {

                    this.loadingCreateCustomer = false;
                    let success = true;
                    const { data } = resp;
                    if (data.success) {
                        const { proposal_info, aplics_order_info } = data;
                        if (proposal_info.success) {
                            const { proposal } = proposal_info;
                            this.clickToBuyUrl = aplics_order_info
                                ? aplics_order_info.order_url
                                : "";
                            if (proposal.status.id === "APPROVED") {
                                this.setApprovedMsg(proposal.id);
                                this.showClickToBuy = true;
                                this.dataLayerPush('preautorizacion_bbva_confirmacion', 'APPROVED', proposal.id);
                            } else if (proposal.status.id === "DENIED") {
                                this.setDeniedMsg();
                                this.showClickToBuy = false;
                                this.dataLayerPush('preautorizacion_bbva_confirmacion', 'DENIED');
                            }
                            this.showThankYouMsg = true;
                            this.scrollDownTo("bbva-form-f2");
                        } else {
                            success = false;
                        }
                    } else {
                        success = false;
                    }
                    if (!success) {
                        this.showSwalError(
                            "Hubo un error al procesar tu solicitud.",
                            "Inténtalo de nuevo más tarde"
                        );
                    }
                })
                .catch((err) => {
                    console.log("/bbva/create-customer err", err);
                    this.loadingCreateCustomer = false;

                    let {
                        response: { data, status },
                    } = err;

                    let msg = "";

                    if (status === 422) {
                        Object.keys(data.errors).forEach((key) => {
                            msg += data.errors[key][0];
                        });
                    } else if (status >= 400 && status < 500) {
                        msg = data.errors[0];
                    } else {
                        msg = "Inténtalo de nuevo más tarde";
                    }

                    this.showSwalError(
                        "Hubo un error al procesar tu solicitud.",
                        msg
                    );
                    // console.log(
                    //     "/bbva/create-customer error",
                    //     data.response_info
                    // );
                });
        },
        // Función para establecer el mensaje final cuando
        // es aprobada la pre autorización
        setApprovedMsg(proposalId) {
            this.$nextTick(() => {
                this.thankYouMsg = `<p class="font-medium text-2xl lg:text-3xl leading-tight text-center">¡FELICIDADES${this.fullName ? ' ' + this.fullName : ""
                    }!</p>
                <p class="text-lg lg:text-xl leading-tight mt-2">La preautorización de tu crédito se ha completado con éxito, en breve nos comunicaremos contigo vía telefónica.</p>
                <p class="text-lg lg:text-xl leading-tight mt-2">Folio: ${proposalId}</p>`;
            })
        },
        // Función para establecer el mensaje final cuando es
        // denegada la pre autorización
        setDeniedMsg() {
            this.$nextTick(() => {
                this.thankYouMsg = `<p class="font-medium text-2xl lg:text-3xl leading-tight text-center">¡HOLA ${this.fullName ? ' ' + this.fullName : ""
                    }!</p>
                <p class="text-lg lg:text-xl leading-tight mt-2">En breve nos comunicaremos contigo vía telefónica para indicarte el estado actual de tu solicitud de crédito.</p>`;
            })
        },
        // Función para redirigir a la url de Clik to buy
        goToClickToBuy() {

            let url_to_open = this.clickToBuyUrl;

            if(this.isIframe){
                const encodedClickToBuyUrl = btoa(this.clickToBuyUrl);
                url_to_open = this.url + '/iframe-aplics-c2b/continuar-solicitud/?aplics_c2b_url=?' + encodedClickToBuyUrl;
                // Abrimos clickToBuy como si fuera un iframe
                // window.open(url_to_open, "_parent").focus();
            }
            window.open(url_to_open, "_parent").focus();
        },
        // Función para redirigir a la sección de contacto del
        // distribuidor seleccionado
        goToDealerContact() {
            window.open(this.dealerContactUrl, "_parent").focus();
        },
        // goToHomePage() {
        //     window
        //         .open(
        //             this.appEnv === "production"
        //                 ? "https://www.hyundai.com.mx/preventa-hibridos/"
        //                 : "https://www-stg.hyundai.com.mx/preventa-hibridos/",
        //             "_parent"
        //         )
        //         .focus();
        // },
        // Función para mostrar el modal del Aviso de Privacidad
        onClickPrivacy() {
            this.showModals.personalData = false;
            this.showModals.privacyPolicy = true;
        },
        // Función para mostrar el 1er formulario si se
        // cumplen las condiciones requeridas
        onClickMainCheck(e) {
            if (this.validateEmail(this.mainEmail) && !this.mainCheck) {
                this.mainCheck = true;
                this.scrollDownTo("bbva-form-1");
            } else if (this.mainCheck) {
                this.mainCheck = false;
            } else {
                e.preventDefault();
                this.showSwalError(
                    "Email inválido",
                    "Para continuar introduce un email válido."
                );
            }
        },
        // Función para mostrar una alerta de error
        showSwalError(title, msg) {
            Swal.fire({
                icon: "error",
                title: `<h3 class="text-2xl leading-tight font-medium">${title}</h3>`,
                html: msg,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton:
                        "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                },
                buttonsStyling: false,
                returnFocus: false,
            });
        },
        // Función para mostrar un menaje de éxito
        showSwalSuccess(title, msg = "", showBtn = false) {
            Swal.fire({
                showConfirmButton: showBtn,
                timer: showBtn ? undefined : 2000,
                returnFocus: false,
                icon: "success",
                title: `<h3 class="text-2xl leading-tight font-medium">${title}</h3>`,
                html: msg,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton:
                        "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                },
                buttonsStyling: false,
            });
        },
        // Función para mostrar un mensaje de error
        // si se intenta continuar con los formularios
        // y se está cargando los catalogos para evitar el avance
        onChargingCatalogs() {
            this.showSwalError(
                "Cargando catalogos",
                "Debes esperar a que carguen los catalogos para poder continuar"
            );
        },
        // Función para validar el email para cargar el avance
        validateEmail(email) {
            const regexp =
                /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

            return regexp.test(email);
        },
        // Función para obtener el avance de los forularios
        getProgress() {
            if (this.validateEmail(this.mainEmail)) {
                this.gettingProgress = true;
                axios
                    .get("/aplics/c2b/loan-progress", {
                        params: {
                            email: this.mainEmail,
                        },
                    })
                    .then(({ data: { success, data } }) => {
                        this.gettingProgress = false;

                        if (success) {
                            this.getProgBtnDisabled = true;
                            const {
                                form_data: { data: inputs },
                            } = data;
                            // Marks the main check to open the actual form
                            this.mainCheck = true;
                            // Set the actual form equals to got in response
                            this.actualForm = inputs.actualForm;
                            // Sets allInputs to inputs got in response
                            this.allInputs = { ...inputs };
                            // Emits an event to fill the forms with inputs that got in response
                            this.$eventBus.$emit(
                                "setFormsInputs",
                                this.allInputs
                            );
                            // Marks as complete the filled forms
                            for (let i = 1; i < inputs.actualForm; i++) {
                                this.$eventBus.$emit(`complete-form-${i}`);
                            }
                            // Function to scroll down to the form open
                            this.scrollDownTo(`bbva-form-${this.actualForm}`);
                            // Calls the function to show success alert
                            this.showSwalSuccess("Avance cargado exitosamente");
                        } else {
                            this.showSwalError(
                                "No se encontró un avance",
                                "No se encontró un avance guardado con ese email. Para guardar tu avance debes ir avanzando en los formularios."
                            );
                        }
                    })
                    .catch((err) => console.log(err));
            } else {
                this.showSwalError(
                    "Email inválido",
                    "Para continuar introduce un email válido."
                );
            }
        },
        // Función para hacer scroll a un determinado elemento
        scrollDownTo(id) {
            this.$nextTick(function () {
                let elem = document.getElementById(id);
                if (elem) {
                    let reqTop = elem.getBoundingClientRect().top;
                    $("html, body").animate(
                        {
                            scrollTop: reqTop + $(window).scrollTop() - 20,
                        },
                        1000
                    );
                }
            });
        },
        // Función para dar formato a los datos de los inputs
        // y guardar el progreso cuando se le da click al botón
        onSaveProgress(formData) {
            this.formatInputs(formData);
            this.saveProgress(formData);
        },
        // Función para guardar el progreso de los formularios
        saveProgress(formData, showSwal = true) {
            if (this.validateEmail(this.mainEmail)) {
                this.savingProgress = true;
                axios
                    .post("/aplics/c2b/loan-progress", {
                        email: this.mainEmail,
                        data: this.allInputs,
                    })
                    .then(({ data: { success, data } }) => {
                        this.savingProgress = false;
                        if (showSwal) {
                            if (success) {
                                this.showSwalSuccess(
                                    "Avance guardado exitosamente"
                                );
                            } else {
                                console.log(data);
                                this.showSwalError(
                                    "Ocurrió un problema al intentar guardar tu avance",
                                    "De cualquier forma puedes continuar con tu pre autorización de crédito digital."
                                );
                            }
                        }
                    })
                    .catch((err) => {
                        this.savingProgress = false;
                        console.log(err);
                        this.showSwalError(
                            "Ocurrió un problema al intentar guardar tu avance",
                            "De cualquier forma puedes continuar con tu pre autorización de crédito digital."
                        );
                    });
            } else {
                this.showSwalError(
                    "Email inválido",
                    "Para continuar introduce un email válido al inicio de esta solicitud."
                );
            }
        },
        // Función para empujar los datos pertinentes al dayalayer
        dataLayerPush(event, status = '', idPre = '') {
            dataLayer.push({
                event: event,
                id_cotizacion: this.dataForF2.quotId,
                plazo: this.dataForF2.term,
                pago_mensual: this.dataForF2.pagoMensual,		// número
                financiamiento: this.dataForF2.montoTotal,		// número
                total_pagar: this.dataForF2.totalAPagar,		// número
                modelo: this.dataForF2.modelName,
                version: this.dataForF2.versionName,
                interes_compra: '',
                distribuidor: this.dataForF2.subName,
                estatus: status,
                id_preautorizacion: idPre,
            });
            // console.log(dataLayer);
        },
        // Función para emitir un evento de formulario completado,
        // empujar los datos del datalayer, mostrar el siguiente
        // formulario y guardar el progreso una vez que el formulario
        // ha sido validado
        onFormValidated(formData) {
            this.$eventBus.$emit(`complete-form-${formData.formNum}`);

            switch (formData.formNum) {
                case 1:
                    this.dataLayerPush('preautorizacion_bbva_datos_personales');
                    break;
                case 2:
                    this.dataLayerPush('preautorizacion_bbva_domicilio_personal');
                    break;
                case 3:
                    this.dataLayerPush('preautorizacion_bbva_datos_economicos');
                    break;
                case 4:
                    this.dataLayerPush('preautorizacion_bbva_datos_contacto');
                    break;
            }

            if (formData.formNum < 4) {
                this.$eventBus.$emit(`show-form-${formData.formNum + 1}`);
                this.formatInputs(formData);
                this.allInputs.actualForm += 1;
            } else {
                this.formsCompleted = true;
                this.formatInputs(formData);
            }

            this.saveProgress(formData, false);
        },
        // Función para establecer el formulario actual y marcar
        // como incompletos los formularios cuando se abre un formulario
        onFormOpen(formNum) {
            this.actualForm = formNum;
            this.formsCompleted = false;
        },
        // Function to formatInputs before send to save progress
        formatInputs(formData) {
            let { formNum, formInputs } = formData;
            switch (formNum) {
                case 1:
                    this.allInputs.actualForm = 1;
                    this.allInputs.firstName = formInputs.firstName;
                    this.allInputs.middleName = formInputs.middleName;
                    this.allInputs.lastName = formInputs.lastName;
                    this.allInputs.secondLastName = formInputs.lastMothersName;
                    this.allInputs.gender_id = formInputs.gender
                        ? formInputs.gender.id
                        : "";
                    this.allInputs.birthDate = formInputs.birthDate;
                    this.allInputs.birthData_country_id = formInputs.country
                        ? formInputs.country.id
                        : "";
                    this.allInputs.birthData_country_description =
                        formInputs.country
                            ? formInputs.country.description
                            : "";
                    this.allInputs.birthData_state_id = formInputs.state
                        ? formInputs.state.id
                        : "";
                    this.allInputs.birthData_state_description =
                        formInputs.state ? formInputs.state.description : "";
                    this.allInputs.rfc = formInputs.rfc;
                    this.allInputs.curp = formInputs.curp;
                    this.allInputs.nationality_id = formInputs.nationality
                        ? formInputs.nationality.id
                        : "";
                    this.allInputs.nationality_description =
                        formInputs.nationality
                            ? formInputs.nationality.description
                            : "";
                    this.allInputs.maritalStatus = formInputs.mStatus
                        ? formInputs.mStatus.id
                        : "";
                    this.allInputs.id_type = formInputs.idType
                        ? formInputs.idType.id
                        : "";
                    this.allInputs.id_num = formInputs.idNum;
                    break;
                case 2:
                    this.allInputs.actualForm = 2;
                    this.allInputs.addresses_state_id = formInputs.state
                        ? formInputs.state.id
                        : "";
                    this.allInputs.addresses_state_description =
                        formInputs.state ? formInputs.state.description : "";
                    this.allInputs.addressName = formInputs.street;
                    this.allInputs.zipCode = formInputs.cp;
                    this.allInputs.colony_id = formInputs.colony
                        ? formInputs.colony.id
                        : "";
                    this.allInputs.colony = formInputs.colony
                        ? formInputs.colony.description
                        : "";
                    this.allInputs.exterior_number = formInputs.outNum;
                    this.allInputs.interior_number = formInputs.intNum;
                    this.allInputs.addressType_id = formInputs.domType
                        ? formInputs.domType.id
                        : "";
                    this.allInputs.ownershipType_id = formInputs.ownType
                        ? formInputs.ownType.id
                        : "";
                    this.allInputs.residenceStartDate =
                        formInputs.residenceYears;
                    this.allInputs.municipality_id = formInputs.municipality
                        ? formInputs.municipality.id
                        : "";
                    this.allInputs.municipality = formInputs.municipality
                        ? formInputs.municipality.description
                        : "";
                    this.allInputs.city = formInputs.city;
                    break;
                case 3:
                    this.allInputs.actualForm = 3;
                    this.allInputs.workPlace_startDate =
                        formInputs.empStartDate;
                    this.allInputs.employmentSituation_id =
                        formInputs.empSituation
                            ? formInputs.empSituation.id
                            : "";
                    this.allInputs.employmentSituation_description =
                        formInputs.empSituation
                            ? formInputs.empSituation.description
                            : "";
                    this.allInputs.education_id = formInputs.edLevel
                        ? formInputs.edLevel.id
                        : "";
                    this.allInputs.education_description = formInputs.edLevel
                        ? formInputs.edLevel.description
                        : "";
                    this.allInputs.dependents = formInputs.depNum;
                    this.allInputs.economicActivity_id = formInputs.ecoActivity
                        ? formInputs.ecoActivity.id
                        : "";
                    this.allInputs.economicActivity_description =
                        formInputs.ecoActivity
                            ? formInputs.ecoActivity.description
                            : "";
                    this.allInputs.occupationType_id = formInputs.profession
                        ? formInputs.profession.id
                        : "";
                    this.allInputs.occupationType_description =
                        formInputs.profession
                            ? formInputs.profession.description
                            : "";
                    this.allInputs.fixed_income = formInputs.fixedIncome;
                    this.allInputs.variable_income = formInputs.varIncome;
                    break;
                case 4:
                    this.allInputs.actualForm = 4;
                    this.allInputs.email = formInputs.email;
                    this.allInputs.mobile_number = formInputs.phone;
                    this.allInputs.phoneCompany_id = formInputs.mobCompany
                        ? formInputs.mobCompany.id
                        : "";
                    this.allInputs.phoneCompany_description =
                        formInputs.mobCompany
                            ? formInputs.mobCompany.description
                            : "";
                    this.allInputs.hasCreditCard = formInputs.creditCard;
                    this.allInputs.lastFourDigits = formInputs.lastNumsCc;
                    this.allInputs.hasAutoLoan = formInputs.autoCredit;
                    this.allInputs.hasMortgageLoan = formInputs.mortCredit;
                    this.allInputs.checkCreditScore =
                        formInputs.checkCreditScore;
                    this.allInputs.treatmentData = formInputs.treatmentData;
                    this.allInputs.termsConditions = formInputs.termsConditions;
                    this.allInputs.hmm = formInputs.hmm;
                    break;
                default:
                    break;
            }
        },
    },
    computed: {
        // Retorna el nombre completo del usuario
        fullName() {
            return `${this.allInputs.firstName ? this.allInputs.firstName + " " : ""
                }${this.allInputs.middleName ? this.allInputs.middleName + " " : ""
                }${this.allInputs.lastName ? this.allInputs.lastName + " " : ""}${this.allInputs.secondLastName
                    ? this.allInputs.secondLastName
                    : ""
                }`;
        },
        // Retorna la url de la sección de contacto del
        // distribuidor seleccionado
        dealerContactUrl() {
            return `${this.url}/${this.dataForF2.webpage}/contacto`;
        },
    },
};
</script>

<style>
.checkbox-container .checkmark:after {
    border: solid #00aad2;
    border-width: 0 4px 4px 0;
}

@keyframes email-input {
    from {
        opacity: 0;
        left: 180px;
    }

    to {
        opacity: 1;
        left: 0px;
    }
}

.bbva-form-2 .show-email-input {
    animation: email-input 0.7s ease-out forwards;
}
</style>
